module.exports = __webpack_public_path__ + "static/assets/cef8c24f0dc324f76f6820874714c854.png";